import React from 'react';
import styled from 'styled-components';
import { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import Popup from 'reactjs-popup';
import PopupTable from '../../../../PopupTable';
import * as XLSX from 'xlsx';
import { TableHead, TextField, Chip, Checkbox } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import dayjs from 'dayjs';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import IconButton from '@mui/material/IconButton';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import {TableContStyle, TableHeadStyle } from '../../../../../Styles/TableStyles';
import {HeadingWrap, Span, CommonButton } from '../../../../../Styles/CommonStyles';
import { useGetAssetsFinalQuery } from '../../../../../features/addassets/addassetfinalApiSlice';
import { useDeleteMultiAssetsMutation, useEditAssettagsMutation,  useGetAssetsQuery } from '../../../../../features/addassets/addassetApiSlice';
import UnivMyAssetComp from '../../../Myasset/UnivMyAssetComp';
import { useUploadFileMutation } from '../../../../../features/fileupload/fileuploadApiSlice';
import { useAddNewSurveyAssetMutation } from '../../../../../features/surveyassets/surveyassetsApiSlice';


const HeadingField = styled.div`
  font-weight: bold;
  margin-bottom:20px;
`
const HeadingWrap2 =styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-left:10px;
  margin-top: 10px;
  margin-bottom: 5px;
  font-family: "Roboto","Helvetica","Arial",sans-serif;
  font-size: 24px;
  font-weight: 700;
  color: #5C5891;
`
const BulkWrapper = styled.div`
  display: flex;
  align-items:center;
`
const InputFile = styled.input`
  width: 180px;
  display: none;
`
const CustomFileUploadButton = styled.label`
  /* Add your desired button styles */
  background-color: #4caf50; /* Green */
  color: white;
  padding: 10px 15px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
`
const SelectFileReset = styled.button`
  margin-right: 10px;
`
const SubmitButton = styled(CommonButton)`
  height:"40px";
  margin-top:"0px";
  margin-bottom:"0px";
`
const FinalSubmitButton = styled(CommonButton)`
  height:"40px";
  width: 200px;
  margin-top:"0px";
  margin-bottom:"0px";
  margin-left:"0px";
`
const InputAsetfmWrapper = styled.div`
  margin-top: 20px;
  margin-bottom: 20px;  
`

const UploadPdfWrapper = styled.div`
  display: flex;
  align-items:center;
  margin-top: 20px;
  margin-bottom: 10px;
`
const ViewButton = styled.button`
  background-color: #4caf50; /* Green */
  color: white;
  padding: 10px 15px;
  border: none;
  border-radius: 5px;
  margin-right:5px;
  margin-left: 5px;
  cursor: pointer;  
`
function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

const checkDuplicates = (data, key) => {
  const seen = new Set();
  const duplicates = new Set();

  data.forEach((row) => {
    if (row[key]) {
      const value = row[key];
      if (seen.has(value)) {
        duplicates.add(value);
      } else {
        seen.add(value);
      }
    }
  });

  return duplicates;
};

const FinalObjInitialVal = {
  remarks:""
}

let SurveyAssetObject = {
  surveyid:"",
  oem_tags:[],
  survey_date:null,
  remarks:""
}

let jsonData = {collection:"surveyreport", data:{}, type:"addnew", oldPath:"", dynamicKey:"surveypdf"}; // Update JSON data with actual data.
const folderName = "surveyreport";

const SurveyAssets = () => {

  const inputFile = useRef(null);
  const inputPdfFile = useRef(null);  
  const [file, setFile] = useState(null);
  const [fileName, setFileName] = useState("");
  const [fileError, setFileError] = useState(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [tabledata, setTabledata]= useState([]);
  const [selectedfile, setSelectedFile] = useState(null);
  const [remarks, setRemarks] = useState("");
  const [surveyDate, setSurveyDate] = useState("");
  const [finalSubClicked, setFinalSubClicked] = useState(false);
  

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - tabledata.length) : 0;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const [uploadFile, { isLoading:uploadLoading }] = useUploadFileMutation();
  const [addsurveyassets, { isLoading:addsurveyassetLoading }] = useAddNewSurveyAssetMutation();
  const [deletemultiassets] = useDeleteMultiAssetsMutation();

  const { allassets } = useGetAssetsFinalQuery('allassetlist', {
    selectFromResult: ({ data }) => ({
      allassets: data?.entities
    }),
  })
  const { addassets } = useGetAssetsQuery('addassets', {
    selectFromResult: ({ data }) => ({
      addassets: data?.entities
    }),
  })

  const [editAssetTags, { isLoading }] = useEditAssettagsMutation();
  


  const handleButtonClick = () => {
    inputFile.current.click();
  };

  const handleviewFile = () =>{
    window.open(URL.createObjectURL(selectedfile), '_blank');
  }

  const deleteSelectFile = () => {
    if(inputFile.current){
      inputFile.current.value = "";
      inputFile.current.type = "text"; 
      inputFile.current.type = "file";
      setFile(null)
      setTabledata([])
    }
  }

  const deleteSelectPDFFile = () => {
    if (inputPdfFile.current) {
      inputPdfFile.current.value = null;
      inputPdfFile.current.type = "text";
      inputPdfFile.current.type = "file";
      setSelectedFile(null);
    }
  }

  const handleSurveyDate = (event, name) => {    
    if(event?.$d) {
      setSurveyDate(event?.$d.toISOString())
    }
  }
console.log(tabledata)
  const handleFinalSubmit = async (event) => {
    event.preventDefault();
    const tableIds = tabledata.map(x => x._id);
    let body = {};
    const now = new Date();
    body.surveyid = `SR-${now.getTime()}`
    body.oem_tags = tabledata.map(x => x.oem_tag);
    body.survey_date = surveyDate;
    body.remarks = remarks;
    jsonData.data = body;
    const formData = new FormData();
    if(selectedfile) formData.append('file', selectedfile);
    formData.append('jsonData', JSON.stringify(jsonData));
    try {
      const res = await uploadFile({ formData, folder: folderName }).unwrap();
      const res2 = await addsurveyassets({"array":tabledata}).unwrap();
      const res3 = await deletemultiassets({"array":tableIds}).unwrap();
      console.log(res)
      console.log(res2)
      console.log(res3)
      setRemarks("")
      setSurveyDate("")
      setTabledata([])
      setFile(null)
      setSelectedFile(null);
      return alert(`${res.message}, ${res2.message}, ${res3.message}`);
    } catch (err) {
      console.log(err)
    }

  }

  // handle file upload
  const handlePdfFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      if (file.type === 'application/pdf') {
        setSelectedFile(file)       
      } else {
        alert('Please select only PDF file.');
        event.target.value = null;
      }
    }
  }

  const handlePdfUploadButtonClick = () => {
    inputPdfFile?.current?.click();
  };

  const handleformInput = (event) => {
    setRemarks(event.target.value);
  }

  const onBulkSubmit = (e) =>{
    e.preventDefault();
    if(!file?.length){
      return alert("Please Upload file before confirming");
    }
    console.log(file.map(x => x?.oem_tag))
    const finalArray = Object.values(allassets).filter((asset) => file.map(x => x?.oem_tag).includes(asset?.oem_tag) );
    setTabledata(finalArray);
  }

  const fileType = ["application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "application/vnd.ms-excel"]

  const handleChangeOemTags = async (e) => {
    const selectedFile = e.target.files[0];
  
    if (!selectedFile) {
      setFileError("No file selected");
      setFile(null);
      return;
    }
  
    if (!fileType.includes(selectedFile.type)) {
      setFileError("Please select a valid file type");
      setFile(null);
      return;
    }
  
    const reader = new FileReader();
  
    reader.onload = (e) => {
      try {
        setFileError(null);
        const workbook = XLSX.read(e.target.result, { type: "buffer" });
        const worksheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[worksheetName];
        let data = XLSX.utils.sheet_to_json(worksheet);
  
        // Convert all values to strings and trim spaces
        data = data.map((row) =>
          Object.fromEntries(
            Object.entries(row).map(([key, value]) => [
              key,
              value !== undefined && value !== null ? String(value).trim() : "",
            ])
          )
        );
  
        // Check for duplicates using checkDuplicates function
        const oemTagDuplicates = checkDuplicates(data, "oem_tag");
        const orgTagDuplicates = checkDuplicates(data, "org_tag");
  
        if (oemTagDuplicates.size || orgTagDuplicates.size) {
          inputFile.current.value = null; // Clear the file input only if duplicates exist
          alert(
            `Duplicate values found:\n` +
              `OEM_Tags: ${oemTagDuplicates.size ? [...oemTagDuplicates].join(", ") : "None"}\n` +
              `ORG_Tags: ${orgTagDuplicates.size ? [...orgTagDuplicates].join(", ") : "None"}`
          );
          return;
        }
  
        // Successfully processed file
        setFileName(selectedFile.name);
        setFile(data);
      } catch (error) {
        console.error("Error processing file:", error);
        setFileError("An error occurred while processing the file");
        setFile(null);
      }
    };
  
    reader.onerror = () => {
      setFileError("An error occurred while reading the file");
      setFile(null);
    };
  
    reader.readAsArrayBuffer(selectedFile);
  };
  
  
  
  const onConfirmFinal = async () => {
    const body = {"type":"oemtoorg", "data":tabledata};
    const result = await editAssetTags(body);
    console.log(result.data.message);
    alert(result.data.message);
  }
  console.log(tabledata)

  const keyArrayDwld = ["category","name", "oem_tag","org_tag","oem", "alloc_user", "alloc_ofc", "specification","pur_store","in_transit", "cur_store","cur_loc_name", "purchase_date", "installation_date", "warrantyexp_date", "unit_price", "last_trans_date"]
  const columnFilter = [ "OEM/ORG Tag", "OEM/Brand",  "Store", "Location", "Purchase Date", "Warranty Date", "Detail", "Model"]
  return (
    <>
    <HeadingWrap>
      <Span>Survey Report Assets</Span>
    </HeadingWrap>

    <HeadingWrap2>
      <HeadingField>Upload File</HeadingField> 
    </HeadingWrap2>
   <form onSubmit={onBulkSubmit}>

    <BulkWrapper>
      <InputFile type="file" onChange={handleChangeOemTags} ref={inputFile} />
      <CustomFileUploadButton htmlFor="file-upload" onClick={handleButtonClick}>
        Upload File
      </CustomFileUploadButton>
      {file && <><span>{fileName}</span><SelectFileReset type='button' onClick={() => deleteSelectFile()} >&times;</SelectFileReset>
      <Popup trigger={<SubmitButton type='button'>View File</SubmitButton>} position="right center" modal nested>
        <PopupTable props={file}/>
      </Popup></>}
      <SubmitButton type='submit'>Confirm</SubmitButton>
      </BulkWrapper>
    </form>
    {tabledata?.length?<>
   <UnivMyAssetComp keyArrayDwld = {keyArrayDwld} finalData = {tabledata} columnFilter = {columnFilter} />

    <UploadPdfWrapper>
      <InputFile type="file" onChange={handlePdfFileChange} ref={inputPdfFile}/>
      <CustomFileUploadButton htmlFor="file-upload" onClick={handlePdfUploadButtonClick}>
        Upload reference document as a single PDF only
      </CustomFileUploadButton>
      {selectedfile  && <><span>{selectedfile.name}</span><SelectFileReset type='button' onClick={() => deleteSelectPDFFile()} >&times;</SelectFileReset><ViewButton type='button' onClick={handleviewFile}>View File</ViewButton></>}
    </UploadPdfWrapper>
    
    <InputAsetfmWrapper>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DemoContainer components={['DatePicker', 'DatePicker']}>
          <DateTimePicker
            label="Survey Report date"
            value={dayjs(surveyDate)}
            format="DD/MM/YYYY hh:mm a"
            onChange={(event) => handleSurveyDate(event, 'survey_date')}
          />
        </DemoContainer>
      </LocalizationProvider>
    </InputAsetfmWrapper>

    <InputAsetfmWrapper>
      <TextField
        style={{ width: '600px' }}
        value={remarks}
        name="remarks"
        onChange={handleformInput}
        label="Remarks"
        size="small"
        variant="outlined"
        multiline  // Enables multiple lines
        minRows={3} // Adjust as needed
      />
    </InputAsetfmWrapper>


    <FinalSubmitButton type='button' onClick={handleFinalSubmit}>Final Submit</FinalSubmitButton>

    
    </>:null}
    </>

  )
}

export default SurveyAssets